namespace $.$$ {

	export class $shm_hitalama_project_codex extends $.$shm_hitalama_project_codex {

		project_id() {
			return this.$.$mol_state_arg.value( 'project' ) ?? ''
		}

		project() {
			return this.$.$shm_projects_data.record( this.project_id() )
		}

		width_px() {
			return `${ this.width() }px`
		}

		override server_url( next?: string ) {
			if( next !== undefined ) return next
			const suffix = this.$.$shm_projects_config.domain_suffix()
			if( !suffix ) return 'http://127.0.0.1:4870'
			const token = this.$.$shm_projects_config.agent_token()
			const prefix = token ? `/__hitalama_tunnel/${ encodeURIComponent( token ) }` : ''
			return `https://codex-dev.${ suffix }${ prefix }`
		}

		session_prefix() {
			return `[project:${ this.project_id() }] `
		}

		@ $mol_mem
		sessions_data( next?: $shm_codex_api_thread[] ) {
			if( next !== undefined ) return next
			const prefix = this.session_prefix()
			return $mol_wire_sync( $shm_codex_api ).sessions( this.server_url() ).data
				.filter( session => session.name?.startsWith( prefix ) )
		}

		session_upsert( session: $shm_codex_api_thread ) {
			if( !session.name?.startsWith( this.session_prefix() ) ) return
			const sessions = this.sessions_data()
			const current = sessions.findIndex( item => item.id === session.id )
			if( current === -1 ) return this.sessions_data( [ session, ... sessions ] )
			const next = [ ... sessions ]
			next[ current ] = { ... next[ current ], ... session }
			this.sessions_data( next )
		}

		session_title( id: string ) {
			const session = this.sessions_data().find( session => session.id === id )
			const title = session?.name || session?.preview || `Сессия ${ id.slice( 0, 8 ) }`
			return title.startsWith( this.session_prefix() ) ? title.slice( this.session_prefix().length ) : title
		}

		@ $mol_mem
		override session_id( next?: string ) {
			const key = `shm_projects:${ this.project_id() }:codex_session`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? ''
			const stored = this.$.$mol_state_local.value< string >( key ) ?? ''
			if( stored && this.sessions_data().some( session => session.id === stored ) ) return stored
			const latest = this.sessions_data()[0]?.id ?? ''
			if( latest ) this.$.$mol_state_local.value( key, latest )
			return latest
		}

		create_later() {
			const title = this.new_session_title().trim() || 'Новая сессия'
			const project = this.project()
			const result = $mol_wire_sync( $shm_codex_api ).create_session(
				this.server_url(),
				`${ this.session_prefix() }${ title }`,
				'',
				this.consultation_instruction( project?.title ?? this.project_id() ),
			)
			this.new_session_title( '' )
			this.session_upsert( result.thread )
			this.session_id( result.thread.id )
		}

		consultation_instruction( title: string ) {
			return [
				`Это консультационная сессия проекта «${ title }».`,
				'Отвечай на вопросы о проекте и его коде кратко и по существу.',
				'Не изменяй файлы и не начинай реализацию из этого окна.',
				'Если пользователь просит внести изменения, предложи открыть вкладку «Разработка» проекта и вставить требования туда.',
			].join( ' ' )
		}

	}

}
